'use client';

import { create } from 'zustand';
import { GLOBAL_NAVIGATION_COLLAPSE_THRESHOLD_PX, GLOBAL_NAVIGATION_EXPANDED_WIDTH_PX, GLOBAL_NAVIGATION_MAX_WIDTH_PX, GLOBAL_NAVIGATION_MIN_EXPANDED_WIDTH_PX } from '@/lib/canvas-shell-layout';

/** Route entry controls visibility; a user's resized width survives route changes. */
export const useGlobalNavigationStore = create<{ collapsed: boolean; resizing: boolean; setResizing: (resizing: boolean) => void; expandedWidth: number; resize: (width: number) => void; collapse: () => void; expand: () => void; toggle: () => void }>((set) => ({
  collapsed: false,
  resizing: false,
  setResizing: resizing => set({ resizing }),
  expandedWidth: GLOBAL_NAVIGATION_EXPANDED_WIDTH_PX,
  resize: width => {
    if (!Number.isFinite(width)) return;
    set(width < GLOBAL_NAVIGATION_COLLAPSE_THRESHOLD_PX ? { collapsed: true } : {
      collapsed: false,
  resizing: false,
  setResizing: resizing => set({ resizing }),
      expandedWidth: Math.round(Math.min(GLOBAL_NAVIGATION_MAX_WIDTH_PX, Math.max(GLOBAL_NAVIGATION_MIN_EXPANDED_WIDTH_PX, width))),
    });
  },
  collapse: () => set({ collapsed: true }),
  expand: () => set({ collapsed: false }),
  toggle: () => set(state => ({ collapsed: !state.collapsed })),
}));
